/* eslint-disable camelcase */
import { API } from "./API";
import { getApiUrl } from "../utils/platform";

export const getK3Docs = (query) => {
  var {
    id,
    docId,
    docIds,
    keyword,
    sortBy,
    type,
    limit = 100,
    offset = 0
  } = query;

  var queryStr = sortBy ? `sort=${sortBy}` : `sort=createdAt`;

  if (id)
    queryStr += `&id=${id}`;

  if (docId)
    queryStr += `&doc_id=${docId}`;

  if (docIds)
    queryStr += `&doc_ids=${docIds}`;

  if (keyword)
    queryStr += `&keyword=${keyword}`;

  if (type)
    queryStr += `&type=${type}`;

  if (limit)
    queryStr += `&limit=${limit}`;

  if (offset)
    queryStr += `&offset=${offset}`;

  return API.get(`${getApiUrl()}/api/k3doc?${queryStr}`);
}

export const setK3Docs = (docs, query = {}) => {
  var { generate_version = false } = query;

  var queryStr = `generate_version=${generate_version}`;

  return API.post(`${getApiUrl()}/api/k3doc?${queryStr}`, docs);
}

export const getK3DocVersions = (doc_mid) => {
  return API.get(`${getApiUrl()}/api/k3doc/doc-mid-versions?doc_mid=${doc_mid}`);
}

export const k3docService = {
  getK3Docs,
  setK3Docs,
  getK3DocVersions
} 